import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';

import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import { getEnv } from '../../../../lib/utils/getEnv';
import { ActionContainer, HeroContent, HeroOverviewContainer, HeroSectionContainer } from './heroSection.styled';

const { VITE_CDN_BASE_URL, VITE_PARTNERS_BASE_URL } = getEnv();

const HeroSection = () => {
  const handleSignUpClick = () => {
    window.location.href = `${VITE_PARTNERS_BASE_URL}/sign-up`;
  };

  const handleBookDemo = () => {
    window.location.href = `https://meetings.hubspot.com/pata/demo`;
  };

  return (
    <HeroSectionContainer>
      <Image
        src={`${VITE_CDN_BASE_URL}/images/image-dog-trainer-hero.webp`}
        alt="Lady training dog in field"
        height={2000}
        width={2000}
      />

      <WidthContainer noBackground>
        <HeroOverviewContainer>
          <HeroContent>
            <TextWithHighlight>
              <h1>
                Manage sessions, simplify admin, and grow with <strong>dog training software </strong>
                built for trainers
              </h1>
            </TextWithHighlight>
            <p>
              Take online bookings, get discovered by pet owners, and keep your schedule full – all in one{' '}
              <strong>simple platform </strong>
              made for trainers.
            </p>

            <ActionContainer>
              <Button onClick={handleSignUpClick}>Sign up for free</Button>
              <Button buttonType="secondary" onClick={handleBookDemo}>
                Book a demo
              </Button>
            </ActionContainer>
          </HeroContent>
          <Image
            src={`${VITE_CDN_BASE_URL}/images/image-dog-trainer-hero.webp`}
            alt="Dog being training with a session booked through Pata booking platform"
            height={2000}
            width={2000}
          />
        </HeroOverviewContainer>
      </WidthContainer>
    </HeroSectionContainer>
  );
};

export default HeroSection;
